import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import ArrowBack from '@material-ui/icons/ArrowBack';
import cn from 'classnames';
import { isEmpty } from 'lodash';
import MainButton from '../MUI/MainButton';

import useStyles from './makeStyles';

const StepsNavigation = ({
  back,
  next,
  children,
  isPreviousDisabled,
  isNextDisabled,
  nextBtnBlock,
  width,
  styles,
}) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <div className={cn(classes.container, (!isEmpty(styles) && styles))}>
      {back && (
        <MainButton
          onClick={back}
          variant="text"
          color="secondary"
          startIcon={<ArrowBack />}
          disabled={isPreviousDisabled}
          className={classes.backButton}
        >
          {t('navigation.back')}
        </MainButton>
      )}
      <div>{children}</div>
      <MainButton
        onClick={next}
        variant="contained"
        color="primary"
        disabled={isNextDisabled}
        width={width}
      >
        {(nextBtnBlock) || t('navigation.next')}
      </MainButton>
    </div>
  );
};

StepsNavigation.propTypes = {
  back: PropTypes.func,
  next: PropTypes.func,
  children: PropTypes.element,
  isPreviousDisabled: PropTypes.bool,
  isNextDisabled: PropTypes.bool,
  nextBtnBlock: PropTypes.element,
  width: PropTypes.string,
  styles: PropTypes.string,
};

StepsNavigation.defaultProps = {
  back: null,
  next: null,
  children: null,
  isPreviousDisabled: false,
  isNextDisabled: false,
  nextBtnBlock: null,
  width: '',
  styles: '',
};

export default StepsNavigation;
